// extracted by mini-css-extract-plugin
module.exports = {"relogioNumero":"style_relogioNumero__2ft6-","relogioDivisao":"style_relogioDivisao__3uqa0"};